import React from 'react';
import ReactDOM from 'react-dom';

function Popup(props) {
    const container = document.getElementById('popup-container');
    if (container == null) {
        return;
    }

    return ReactDOM.createPortal(
        <div className="customPopup">
            <div className="customPopup__content">
                <div className="customPopup__content__header">
                    <div className="customPopup__content__header__title">
                        <p>{props.title}</p>
                    </div>
                    <button className="customPopup__content__header__closeButton" onClick={props.dismiss}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <div className="customPopup__content__body">
                    <p>{props.message}</p>
                    <hr />
                    <button className="customPopup__content__body__clickable customPopup__content__body__clickable--success" onClick={props.dismiss}>{props.dismissButtonText}</button>
                 </div>
            </div>
        </div>,
        container
    );
}

export default Popup;